import { css } from "styled-components";

export const COLORS = {
    blue: '#2f80ed',
    alpha_blue: 'rgba(47, 128, 237, 0.2)',
    error: '#eb5757',
    gray: '#767676',
    alpha_gray: 'rgba(196, 196, 196, 0.3)',
    light_gray: '#c4c4c4',
    black: '#051619',
    wrong: '#e1180b',
    white_gray: '#e8e8e8',
    white: '#fff',
    text_gray: '#333333'
  };


//   Font
export const T1_ko = css`
  color:#fff;
  font-family: 'SUIT';
  font-weight: 700;
  font-size: 120px;
  line-height: 113%;
  /* identical to box height, or 136px */
  letter-spacing: -1px;
`

export const T1_en = css`
  color:#fff;

  font-family: 'Helvetica75';
  font-weight: 700;
  font-size: 103px;
  line-height: 92.5%;
  /* or 95px */
`

export const T2_ko = css`
  color:#fff;
  font-family: 'SUIT';
  font-weight: 900;
  font-size: 100px;
  line-height: 100%;
  /* identical to box height, or 100px */
`

export const T2_en = css`
  color:#fff;
  font-family: 'Helvetica-Black';
  font-style: italic;
  font-weight: 900;
  font-size: 100px;
  line-height: 139.02%;
  /* identical to box height, or 139px */
`


export const T3_ko = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 90px;
  line-height: 121%;
  /* identical to box height, or 109px */
`

export const T3_en = css`
  color:#fff;
  font-family: 'Helvetica-Black';
  font-style: italic;
  font-weight: 900;
  font-size: 70px;
  line-height: 111%;
  /* identical to box height, or 78px */
`

export const T4_ko = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 60px;
  line-height: 121%;
  /* identical to box height, or 73px */
`

export const T4_en = css`
  color:#fff;
  font-family: 'Helvetica75';
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 130.02%;
  /* identical to box height, or 78px */

letter-spacing: -0.01em;
`

export const T5 = css`
  color:#fff;
  font-family: 'Helvetica75';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 121%;
  /* identical to box height, or 58px */
  letter-spacing: 1px;
`

export const T6 = css`
  color:#fff;
  font-family: 'Helvetica75';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 113%;
  /* or 36px */
  letter-spacing: 0.85px;
`

export const Heading1 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 48px;
  line-height: 121%;
  /* identical to box height, or 58px */
`

export const Heading2 = css`
  color:#fff;
  font-family: 'SUIT';
  font-weight: 700;
  font-size: 34px;
  line-height: 120%;
  /* identical to box height, or 41px */
  letter-spacing: -1px;
`

export const Heading3 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 600;
  font-size: 24px;
  line-height: 125%;
    /* identical to box height, or 30px */
`

export const Heading4 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */
`

export const Button1 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 21px;
  line-height: 125%;
  /* or 26px */
  letter-spacing: 1px;
`

export const B1 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 140%;
  /* or 29px */
`

export const B2 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 21px;
  line-height: 151%;
  /* identical to box height, or 32px */
`
export const B3 = css`
  color:#fff;
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 17px;
  line-height: 151%;
  /* or 26px */
`